(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-blog-article"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-blog-high-ceiling"] && !Shopify.designMode) return;
  try {
    
(() => {
  const build = () => document.querySelectorAll('.tls-blog-high-ceiling').forEach(root => {
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!body || !list) return;
    const headings = [...body.querySelectorAll('h2,h3')].filter(h => h.textContent.trim() && !h.closest('.about,.tls-guide-note,.tls-blog-faq details'));
    const fragment = document.createDocumentFragment();
    let number = 0;
    const ids = new Set([...body.querySelectorAll('[id]')].map(n => n.id));
    headings.forEach((h,i) => {
      if (!h.id) {
        const stem = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') || `section-${i+1}`;
        let id = stem, suffix = 2;
        while (ids.has(id)) id = `${stem}-${suffix++}`;
        h.id = id; ids.add(id);
      }
      const li = document.createElement('li');
      li.dataset.level = h.tagName === 'H3' ? '3' : '2';
      const auxiliary = h.id === 'sources' || h.closest('.tls-blog-faq');
      if (auxiliary) li.dataset.auxiliary = 'true';
      if (h.tagName === 'H2' && !auxiliary) {
        const label = document.createElement('span');
        label.className = 'tls-blog-toc__number'; label.textContent = `${++number}.`;
        label.setAttribute('aria-hidden','true'); li.append(label);
      }
      const a = document.createElement('a'); a.href = `#${h.id}`; a.textContent = h.textContent.trim();
      li.append(a); fragment.append(li);
    });
    list.replaceChildren(fragment);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build, {once:true});
  else build();
  document.addEventListener('shopify:section:load', build);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-ch03-article-qa"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-ch05-article-qa"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-ch05-article"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-ch06-article-qa"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (['faq','sources','about'].includes(heading.id)) item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && !['faq','sources','about'].includes(heading.id)) {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-ch06-backend-qa"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (['faq','sources','about'].includes(heading.id)) item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && !['faq','sources','about'].includes(heading.id)) {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-ch08-article-qa"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-ch08-article"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-collection-banner-retro"]) return;
  try {
    
window.addEventListener('click', function(event) {
  const link = event.target.closest('quick-add-modal[open] a[data-tls-pdp-link], quick-add-modal[open] a.product__view-details');
  if (!link) return;
  const fragment = link.getAttribute('href');
  if (!link.classList.contains('product__view-details') && (!fragment || !/^#TLSPDP(?:Information|Delivery|Returns)-/.test(fragment))) return;
  const modal = link.closest('quick-add-modal');
  const titleLink = modal.querySelector('a.product__title[href]');
  if (!titleLink) return;
  const destination = new URL(titleLink.href, window.location.origin);
  const selectors = modal.querySelector('variant-selects');
  const controls = selectors && selectors.querySelectorAll('select, fieldset');
  const optionIds = controls && Array.from(controls, function(control) {
    const selected = control.tagName === 'SELECT' ? control.selectedOptions[0] : control.querySelector('input:checked');
    return selected && selected.dataset.optionValueId;
  });
  if (optionIds && optionIds.length && optionIds.every(id => /^\d+$/.test(id || ''))) {
    destination.searchParams.delete('variant');
    destination.searchParams.set('option_values', optionIds.join(','));
  } else if (!controls || !controls.length) {
    const input = modal.querySelector('product-form input[name="id"]');
    if (input && /^\d+$/.test(input.value)) destination.searchParams.set('variant', input.value);
  } else {
    // Do not navigate with a stale variant when a selection cannot be resolved.
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  destination.hash = link.classList.contains('product__view-details') ? '' : fragment;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(destination.href);
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-collection-guide"] && !Shopify.designMode) return;
  try {
    
function tlsUpdateLampNavHints(){
  document.querySelectorAll('.tls-guide--lamps').forEach((section)=>{
    const nav=section.querySelector('.tls-lamps-nav');
    const hint=section.querySelector('.tls-lamps-nav-hint');
    if(!nav||!hint||nav.dataset.hintReady)return;
    nav.dataset.hintReady='true';
    const update=()=>{hint.hidden=nav.scrollWidth<=nav.clientWidth+1;};
    if(window.ResizeObserver)new ResizeObserver(update).observe(nav);
    else window.addEventListener('resize',update);
    update();
  });
}
tlsUpdateLampNavHints();
document.addEventListener('shopify:section:load',tlsUpdateLampNavHints);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-crystal-article"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (['faq','sources','about'].includes(heading.id)) item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && !['faq','sources','about'].includes(heading.id)) {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-crystal-collection-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tls-crystal-guide-nav')) {
  customElements.define('tls-crystal-guide-nav', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('nav');
      this.prevButton = this.querySelector('.tls-crystal-editorial__nav-prev');
      this.nextButton = this.querySelector('.tls-crystal-editorial__nav-next');
      this.links = [...this.querySelectorAll('[data-crystal-guide-link]')];
      this.targets = this.links.map(link => ({link, section: document.getElementById(link.hash.slice(1))})).filter(item => item.section);
      this.scrollHandler = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.markCurrent(); this.updateEdge(); });
      };
      this.navScrollHandler = () => this.updateEdge();
      this.prevHandler = () => this.nav.scrollBy({left: -Math.max(150, this.nav.clientWidth * 0.65), behavior: 'smooth'});
      this.nextHandler = () => this.nav.scrollBy({left: Math.max(150, this.nav.clientWidth * 0.65), behavior: 'smooth'});
      this.prevButton?.addEventListener('click', this.prevHandler);
      this.nextButton?.addEventListener('click', this.nextHandler);
      this.nav.addEventListener('scroll', this.navScrollHandler, {passive: true});
      window.addEventListener('scroll', this.scrollHandler, {passive: true});
      window.addEventListener('resize', this.scrollHandler);
      this.markCurrent();
      this.updateEdge();
    }
    markCurrent() {
      if (!this.targets?.length) return;
      let current = this.targets[0];
      for (const item of this.targets) {
        if (item.section.getBoundingClientRect().top <= 150) current = item;
      }
      for (const link of this.links) {
        if (link === current.link) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    }
    updateEdge() {
      if (!this.nav) return;
      const atStart = this.nav.scrollLeft <= 2;
      const atEnd = this.nav.scrollLeft + this.nav.clientWidth >= this.nav.scrollWidth - 2;
      this.toggleAttribute('data-scroll-end', atEnd);
      const hasOverflow = this.nav.scrollWidth > this.nav.clientWidth + 2;
      if (this.prevButton) this.prevButton.hidden = atStart || !hasOverflow;
      if (this.nextButton) this.nextButton.hidden = atEnd || !hasOverflow;
    }
    disconnectedCallback() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.nav?.removeEventListener('scroll', this.navScrollHandler);
      this.prevButton?.removeEventListener('click', this.prevHandler);
      this.nextButton?.removeEventListener('click', this.nextHandler);
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-fan-content-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tls-pdp-content-nav')) {
    customElements.define('tls-pdp-content-nav', class extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-pdp-nav]')];
        this.scope = document.getElementById('MainContent') || document.querySelector('main');
        if (!this.scope) return;
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
        };
        this.observer = new MutationObserver((changes) => {
          if (changes.some(change => !this.contains(change.target))) this.queue();
        });
        this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-busy'] });
        this.scrollHandler = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.markCurrent(); });
        };
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        window.addEventListener('resize', this.scrollHandler);
        this.readyHandler = () => this.refresh();
        document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        this.refresh();
      }
      refresh() {
        this.targets = this.links.map(link => {
          const target = document.getElementById(link.hash.slice(1));
          const visible = !!target && !!target.getClientRects().length && !target.closest('[hidden], [aria-busy="true"]');
          link.hidden = !visible;
          return visible ? { link, target } : null;
        }).filter(Boolean);
        this.targets.forEach(({ target }, index) => target.toggleAttribute('data-pdp-separated', index > 0));
        this.hidden = this.targets.length < 2;
        // Purchase shortcuts follow the same visible-section rules as navigation.
        this.scope.querySelectorAll('.tls-pdp-purchase-links a').forEach(link => {
          const target = document.getElementById(link.hash.slice(1));
          link.hidden = !target || !target.getClientRects().length || !!target.closest('[hidden], [aria-busy="true"]');
        });
        this.markCurrent();
      }
      markCurrent() {
        if (!this.targets?.length) return;
        const threshold = 140;
        let current = this.targets[0];
        for (const entry of this.targets) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
        if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) current = this.targets[this.targets.length - 1];
        for (const link of this.links) {
          if (link === current.link) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.scrollFrame);
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener('resize', this.scrollHandler);
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-linear-qa"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-pdp-wall-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tls-wall-content-nav')) {
    customElements.define('tls-wall-content-nav', class extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-pdp-nav]')];
        this.scope = document.getElementById('MainContent') || document.querySelector('main');
        if (!this.scope) return;
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
        };
        this.observer = new MutationObserver((changes) => {
          if (changes.some(change => !this.contains(change.target))) this.queue();
        });
        this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-busy'] });
        this.scrollHandler = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.markCurrent(); });
        };
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        window.addEventListener('resize', this.scrollHandler);
        this.readyHandler = () => this.refresh();
        document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        this.refresh();
      }
      refresh() {
        const purchaseLinks = [...this.scope.querySelectorAll('a[data-tls-pdp-link]')].filter(link => !this.contains(link));
        const seenTargets = new Set();
        for (const link of purchaseLinks) {
          const target = document.getElementById(link.hash.slice(1));
          const visible = !!target && !!target.getClientRects().length && !target.closest('[hidden], [aria-busy="true"]');
          const hide = !visible || seenTargets.has(link.hash);
          if (link.hidden !== hide) link.hidden = hide;
          if (!hide) seenTargets.add(link.hash);
        }
        this.targets = this.links.map(link => {
          const target = document.getElementById(link.hash.slice(1));
          const visible = !!target && !!target.getClientRects().length && !target.closest('[hidden], [aria-busy="true"]');
          link.hidden = !visible;
          return visible ? { link, target } : null;
        }).filter(Boolean);
        this.targets.forEach(({ target }, index) => target.toggleAttribute('data-pdp-separated', index > 0));
        this.hidden = this.targets.length < 2;
        this.markCurrent();
      }
      markCurrent() {
        if (!this.targets?.length) return;
        const threshold = 140;
        let current = this.targets[0];
        for (const entry of this.targets) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
        for (const link of this.links) {
          if (link === current.link) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.scrollFrame);
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener('resize', this.scrollHandler);
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-pe02-guide"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-pe05-guide"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'faqs' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'faqs' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-pe06-guide"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-pendant-pillar"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tls-pillar-qa"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const root = document.currentScript?.closest('.shopify-section') || document;

    const toc = root.querySelector('[data-tls-blog-toc]');

    const body = root.querySelector('[data-tls-blog-body]');

    const list = root.querySelector('[data-tls-blog-toc-list]');

    if (!toc || !body || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));

    if (headings.length < 2) {

      toc.hidden = true;

      return;

    }

    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));

    list.replaceChildren();

    let majorNumber = 0;

    headings.forEach((heading, index) => {

      if (!heading.id) {

        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;

        let id = base;

        let suffix = 2;

        while (usedIds.has(id)) id = `${base}-${suffix++}`;

        heading.id = id;

        usedIds.add(id);

      }

      const item = document.createElement('li');

      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

      const link = document.createElement('a');

      link.href = `#${heading.id}`;

      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');

      if (heading.id === 'faq' || heading.id === 'sources') item.dataset.auxiliary = 'true';
      if (heading.tagName === 'H2' && heading.id !== 'faq' && heading.id !== 'sources') {

        const number = document.createElement('span');

        number.className = 'tls-blog-toc__number';

        number.textContent = `${++majorNumber}.`;

        number.setAttribute('aria-hidden', 'true');

        item.append(number);

      }

      item.append(link);

      list.append(item);

    });

  })();



  (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;
    const toc = root.querySelector('[data-tls-blog-toc]');
    const body = root.querySelector('[data-tls-blog-body]');
    const list = root.querySelector('[data-tls-blog-toc-list]');
    if (!toc || !body || !list || !body.querySelector('#tls-dining-guide')) return;
    const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && !heading.closest('.tls-blog-faq details'));
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }
    const usedIds = new Set([...body.querySelectorAll('[id]')].map((node) => node.id));
    list.replaceChildren();
    let majorNumber = 0;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      if (heading.closest('#sources, .tls-blog-faq')) item.dataset.auxiliary = 'true';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/^\d+[.)]\s*/, '');
      if (heading.tagName === 'H2' && !heading.closest('#sources, .tls-blog-faq')) {
        const number = document.createElement('span');
        number.className = 'tls-blog-toc__number';
        number.textContent = `${++majorNumber}.`;
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
      }
      item.append(link);
      list.append(item);
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
